<template>
  <td>
    <div
      v-if="representativePrice"
      class="price-table-cell"
    >
      <el-tooltip placement="top" :disabled="priceType.is_base_price || (representativePrice && normalPrice && representativePrice.price <= normalPrice.price)">
        <div slot="content">Ez az ár magasabb a normál árnál</div>
        <el-input-localized-numeric
          v-model="representativePrice.price"
          :disabled="!priceType.is_active || !representativePrice.is_active"
          size="mini"
          :class="!priceType.is_base_price && normalPrice && representativePrice.price > normalPrice.price ? 'price-warning' : ''"
          @change="onPriceChange"
        />
      </el-tooltip>
      <div style="margin-top: 5px;" v-if="priceType.is_active">
        <el-switch
          v-model="representativePrice.is_active"
        ></el-switch>
      </div>
      <div
        v-if="changeValue"
        :class="changeValue > 0 ? 'indicator caret-up' : 'indicator caret-down'"
      >
        <i :class="`el-icon-caret-${changeValue > 0 ? 'top' : 'bottom'}`"></i> {{ changeValue | currency }}
      </div>
    </div>
  </td>
</template>

<script>
export default {
  props: ['defaultRepresentativePrice', 'product', 'priceType', 'normalPrice'],
  data() {
    return {
      representativePrice: {
        price: 0,
        is_active: false,
      },
    };
  },
  computed: {
    changeValue() {
      if (this.defaultRepresentativePrice && this.representativePrice) {
        return Math.round((parseFloat(this.representativePrice.price) - parseFloat(this.defaultRepresentativePrice.price)) * 100) / 100;
      } else {
        return 0;
      }
    },
  },
  watch: {
    defaultRepresentativePrice(newVal) {
      if (newVal) {
        this.representativePrice = JSON.parse(JSON.stringify(newVal));
      } else {
        this.representativePrice = { price: 0, is_active: false };
      }
    },
  },
  mounted() {
    if (this.defaultRepresentativePrice) {
      this.representativePrice = JSON.parse(JSON.stringify(this.defaultRepresentativePrice));
    } else {
      this.representativePrice = { price: 0, is_active: false };
    }
  },
  methods: {
    isChanged() {
      if (this.representativePrice && this.defaultRepresentativePrice) {
        return parseFloat(this.representativePrice.price) !== parseFloat(this.defaultRepresentativePrice.price) || this.representativePrice.is_active !== this.defaultRepresentativePrice.is_active;
      } else {
        return false;
      }
    },
    onPriceChange(value) {
      this.representativePrice.price = parseFloat(value.replace(/,/, '.'))
    },
    reCalculate() {
      if (this.priceType.calculation_formula && this.priceType.is_active) {
        this.representativePrice.price = Math.round(eval(this.getCalculation(this.priceType.calculation_formula, this.product)) * (1 + this.product.vat / 100));
      }
    },
    getCalculation(template, properties) {
      var result = template;
      for (let i in properties) {
        const reg = new RegExp("{"+i+"}","g");
        result = result.replace(reg, properties[i]);
      }
      return result;
    }
  },
};
</script>

<style lang="scss">
  .indicator {
    margin-top: 5px;
    &.caret-up {
      color: #67C23A;
    }
    &.caret-down {
      color: #F56C6C;
    }
  }
  .price-table-cell {
    .price-warning {
      .el-input__inner {
        border: 1px solid #E6A23C;
        border-radius: 4px;
      }
      .el-input.is-active .el-input__inner, .el-input__inner:focus {
        border-color: #409EFF;
        outline: 0;
      }
    }
  }
</style>
